import React, { useState, useEffect } from 'react';
import { apiService } from '../../services';
import { utils } from '../../utils';

const TCO: React.FC = () => {
  const [ranking, setRanking] = useState<any[]>([]);
  const [detalhe, setDetalhe] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { loadRanking(); }, []);

  const loadRanking = async () => {
    try {
      setIsLoading(true);
      const res = await apiService.getTcoRanking();
      if (res.success && res.data) setRanking(res.data || []);
    } catch (err: any) {
      utils.showNotification('Erro ao carregar TCO', { type: 'error' });
    } finally { setIsLoading(false); }
  };

  const loadDetalhe = async (veiculoId: number) => {
    try {
      const res = await apiService.getTcoVeiculo(veiculoId);
      if (res.success && res.data) setDetalhe(res.data);
    } catch (err: any) {
      utils.showNotification('Erro ao carregar detalhes', { type: 'error' });
    }
  };

  const formatCurrency = (v: number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
  const formatNumber = (v: number) => new Intl.NumberFormat('pt-BR').format(v || 0);

  if (isLoading) {
    return (
      <div className="page-container">
        <div className="page-header"><h1>TCO - Custo Total de Propriedade</h1></div>
        <div style={{ textAlign: 'center', padding: '100px 20px' }}>
          <div className="loading-spinner-large"></div>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header"><h1>TCO - Custo Total de Propriedade</h1></div>

      <div className="page-content">
        {/* Detalhe do veiculo selecionado */}
        {detalhe && (
          <div className="card" style={{ marginBottom: '20px' }}>
            <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h2>Detalhamento: {detalhe.veiculo.placa} - {detalhe.veiculo.marca} {detalhe.veiculo.modelo}</h2>
              <button className="btn btn-secondary" onClick={() => setDetalhe(null)} style={{ padding: '6px 12px' }}>
                <i className="fas fa-times"></i> Fechar
              </button>
            </div>
            <div className="card-body">
              <div className="dashboard-grid">
                <div className="stat-card">
                  <div className="stat-icon"><i className="fas fa-gas-pump"></i></div>
                  <div className="stat-value">{formatCurrency(detalhe.combustivel)}</div>
                  <div className="stat-label">Combustivel</div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon"><i className="fas fa-shield-alt"></i></div>
                  <div className="stat-value">{formatCurrency(detalhe.manutencao_preventiva)}</div>
                  <div className="stat-label">Manut. Preventiva</div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon"><i className="fas fa-tools"></i></div>
                  <div className="stat-value">{formatCurrency(detalhe.manutencao_corretiva)}</div>
                  <div className="stat-label">Manut. Corretiva</div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon"><i className="fas fa-circle-notch"></i></div>
                  <div className="stat-value">{formatCurrency(detalhe.pneus)}</div>
                  <div className="stat-label">Pneus</div>
                </div>
                <div className="stat-card" style={{ borderTop: '3px solid #04C64F' }}>
                  <div className="stat-icon"><i className="fas fa-calculator"></i></div>
                  <div className="stat-value" style={{ color: '#04C64F' }}>{formatCurrency(detalhe.custo_total)}</div>
                  <div className="stat-label">Custo Total</div>
                </div>
                <div className="stat-card" style={{ borderTop: '3px solid #3498db' }}>
                  <div className="stat-icon"><i className="fas fa-road"></i></div>
                  <div className="stat-value" style={{ color: '#3498db' }}>{formatCurrency(detalhe.custo_por_km)}/km</div>
                  <div className="stat-label">Custo por KM ({formatNumber(detalhe.veiculo.km)} km)</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Ranking */}
        <div className="card">
          <div className="card-header"><h2>Ranking de Custo por Veiculo</h2></div>
          <div className="card-body">
            {ranking.length === 0 ? (
              <div className="empty-state">
                <i className="fas fa-chart-bar empty-state-icon"></i>
                <h3>Nenhum dado de custo disponivel.</h3>
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Veiculo</th>
                      <th>Combustivel</th>
                      <th>Preventiva</th>
                      <th>Corretiva</th>
                      <th>Pneus</th>
                      <th>Custo Total</th>
                      <th>Custo/km</th>
                      <th>Acoes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ranking.map((v, i) => {
                      const custoTotal = parseFloat(v.custo_total) || 0;
                      const km = v.quilometragem_atual || 0;
                      const custoPorKm = km > 0 ? custoTotal / km : 0;
                      return (
                        <tr key={v.id}>
                          <td><strong>{i + 1}</strong></td>
                          <td><strong>{v.placa}</strong> <span style={{ color: '#7f8c8d' }}>{v.marca} {v.modelo}</span></td>
                          <td>{formatCurrency(v.custo_combustivel)}</td>
                          <td>{formatCurrency(v.custo_preventiva)}</td>
                          <td>{formatCurrency(v.custo_corretiva)}</td>
                          <td>{formatCurrency(v.custo_pneus)}</td>
                          <td><strong>{formatCurrency(custoTotal)}</strong></td>
                          <td>{formatCurrency(custoPorKm)}/km</td>
                          <td>
                            <button className="btn-view" onClick={() => loadDetalhe(v.id)} title="Detalhes">
                              <i className="fas fa-chart-pie"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TCO;
